const HOME_LINK = 'https://res.cloudinary.com/dkyb14ghi/image/upload/v1696186156/webAsset/Home/';

const HOME_ASSET = {
  projectCard: `${HOME_LINK}iflidik92nye0zujbbv6`,
  halfCircle: `${HOME_LINK}sgthgnkvb6c967ufjyep`,
  notesCard: `${HOME_LINK}hnezmcme8tt8j2afqfsp`,
  screen: `${HOME_LINK}xzhikpgsdlfuebu8sn0i`,
  munshi: `${HOME_LINK}k5ihd6x3m22qm8jhqxs4`,
  corporateUser: `${HOME_LINK}kuuxpz4xpsuqh0x6tuju`,
  updates: `${HOME_LINK}vmhmonmbqwmps2ku29ic`,
  profile: `${HOME_LINK}zhhm8mnfam7l27xx5uc6`,
  more: `${HOME_LINK}cra0bgfaz5wqlcekvq7f`,
  background: `${HOME_LINK}dpcqsnzmh7ohhjtjrmpn`,
  schedule: `${HOME_LINK}iokeuiid1b3odxuealnu`,
  learn: `${HOME_LINK}o5yufpdyejweqsizhit9`,
  grow: `${HOME_LINK}egq0kcptcuzihsjo13bp`,
  blog: `${HOME_LINK}rmwh0bjqqg9cqxxceqss`,
  hexagon1: `${HOME_LINK}pol1_c3qxnb`,
  hexagon2: `${HOME_LINK}pol2_pd7hsy`,
  hexagon3: `${HOME_LINK}pol3_sni5gx`,
  collab: `${HOME_LINK}eeiv1p5g9galvqn7fzfq`,
  blogsCard: `${HOME_LINK}hzzln9hzmdwyothupbxr`,
  tick: `${HOME_LINK}hxrivyzpanixljdwwfln`,
};

const BLOG_LINK = 'https://res.cloudinary.com/dkyb14ghi/image/upload/v1696186156/webAsset/Blogs/';
const BLOG_ASSET = {
  whiteBlank: `${BLOG_LINK}pddwec4iokumgoouozlo`,
  technology: `${BLOG_LINK}fq07ufcjstumepo2kirv`,
  payment: `${BLOG_LINK}tv6ajf5s7zfqnqqe7ivn`,
  shopping: `${BLOG_LINK}tcoxlt5lsw36fhetp3ji`,
  savings: `${BLOG_LINK}bkkofl3r7n6f3htneql9`,
  blogIcon: `${BLOG_LINK}vzzebd8ts1ptwxcsns1w`,
  fitness: `${BLOG_LINK}dbyoz5tm36kaqu32pdmp`,
  education: `${BLOG_LINK}bcs3c33ddfh2me3i7tmo`,
  blogBG: `${BLOG_LINK}t61flv03gbrccq7x8nzl`,
};

const DASHBOARD_LINK =
  'https://res.cloudinary.com/dkyb14ghi/image/upload/v1696186156/webAsset/Dashboard/';

const DASHBOARD_ASSET = {
  mess: `${DASHBOARD_LINK}pevyuxa7tlfkzqqhy1qk`,
  horn_bg: `${DASHBOARD_LINK}yfbauszrs0wavj78kwgl`,
  calender: `${DASHBOARD_LINK}zzwj6aknuekiwtl6xtid`,
  building: `${DASHBOARD_LINK}n431f8afujezuxcnptox`,
  small_horn: `${DASHBOARD_LINK}uhqpedj5sgiam8y6a7ds`,
  events: `${DASHBOARD_LINK}wzcuobq05dnrfrjlph4k`,
};

const FOOTER_ASSET = {
  vidkarya_footer:
    'https://res.cloudinary.com/dkyb14ghi/image/upload/v1696186156/webAsset/Footer/yighugmsgm9pwie35ohe',
};

const NAVBAR_ASSET = {
  vidNameLogo:
    'https://res.cloudinary.com/dkyb14ghi/image/upload/v1696186156/webAsset/Navbar/erl1kao3wfywjrayrkv0',
  userLogo:
    'https://res.cloudinary.com/dkyb14ghi/image/upload/v1696186156/webAsset/Footer/w6dw3u8nfviips6vx5qi',
};

const NOTES_LINK = 'https://res.cloudinary.com/dkyb14ghi/image/upload/v1696186156/webAsset/Notes/';

const NOTES_ASSET = {
  noData: `${NOTES_LINK}lqeyi3zg39tsg0hrfrlg`,
  greenNotesIcon: `${NOTES_LINK}mbjrqavibtll2sslqvdm`,
  greenNotesIconSmall: `${NOTES_LINK}nxggsozi6kodnluy0i2u`,
  carousel: `${NOTES_LINK}j5eru1xlbfwmk0rvhdpn`,
  mathNotesIcon: `${NOTES_LINK}segubnlwazkswglk7sij`,
  quantumNotesIcon: `${NOTES_LINK}vtjpqbw6ovvngh9vtylh`,
};

const PROJECT_LINK =
  'https://res.cloudinary.com/dkyb14ghi/image/upload/v1696186156/webAsset/Project/';

const PROJECT_ASSET = {
  userIcon: `${PROJECT_LINK}sxz1lkh0nqbzm0nf388u`,
  search: `${PROJECT_LINK}ew4y77mn24zeidc5tygw`,
  techStack: `${PROJECT_LINK}vnnc1pkj7wnka9e6gccs`,
  defaultProjectIcon: `${PROJECT_LINK}fyiysusdk69yeobaig9e`,
  postedIcon: `${PROJECT_LINK}kijovxsvm7tj0klqwchg`,
  bookmarkIcon: `${PROJECT_LINK}zkzszwsdwa3kyzcqz02b`,
};

const ABOUT_LINK = 'https://res.cloudinary.com/dkyb14ghi/image/upload/v1699534487/webAsset/About';


const ABOUT_ASSET = {
  brandLogo: `${ABOUT_LINK}/iq7cvdcdntevydrdgiil`,
  founderCoverPic: `${ABOUT_LINK}/teamcover.jpg`,
  keshav_PhotoURL: `${ABOUT_LINK}/keshav.jpg`,
  hemant_PhotoURL: `${ABOUT_LINK}/hemant.jpg`,
  lucky_PhotoURL: `${ABOUT_LINK}/lucky.jpg`,
  brij_PhotoURL: `${ABOUT_LINK}/brij.jpg`,
  chaitanya_PhotoURL: `${ABOUT_LINK}/chaitanya.jpg`,
};

const COURSE_STR_LINK =
  'https://res.cloudinary.com/dkyb14ghi/image/upload/v1700465250/webAsset/courseStructures';

const COURSE_STR_ASSET = {
  landingVector: `${COURSE_STR_LINK}/landingVector`,
};

export {
  HOME_ASSET,
  BLOG_ASSET,
  DASHBOARD_ASSET,
  FOOTER_ASSET,
  NAVBAR_ASSET,
  NOTES_ASSET,
  PROJECT_ASSET,
  ABOUT_ASSET,
  COURSE_STR_ASSET,
};
